import { useEffect, useRef } from 'react'

export const useMapFooter = (
  containerRef: React.RefObject<HTMLDivElement | null>,
) => {
  const footerRef = useRef<HTMLDivElement | null>(null)
  const styleRef = useRef<HTMLStyleElement | null>(null)

  useEffect(() => {
    if (!containerRef.current) return

    const footer = document.createElement('div')
    footer.className = 'f4map-footer'
    footer.style.cssText = `
      position: absolute;
      bottom: 0;
      right: 0;
      z-index: 1000;
    `

    footer.innerHTML = `
      <div class="f4map-footer-text">
        <span class="f4map-copyright">
          <a class="f4map-link" href="https://lights-on.pro" target="_blank">Lights-On&nbsp;©&nbsp;Lights-On</a>
        </span>
        <span class="f4map-osm-contributors">
          Map data&nbsp;©&nbsp;<a class="f4map-osm-contributors-link" href="https://www.openstreetmap.org/copyright" target="_blank">OpenStreetMap contributors</a>
        </span>
      </div>
    `

    const style = document.createElement('style')
    style.textContent = `
      .f4map-footer {
        white-space: nowrap;
        line-height: 16px;
      }
      
      .f4map-footer-text {
        display: inline-block;
        background: rgba(255, 255, 255, 0.8);
        font-size: 10px;
        line-height: 16px;
        color: #000;
        padding-left: 8px;
      }
      
      .f4map-copyright,
      .f4map-osm-contributors {
        margin-right: 12px;
      }
      
      .f4map-link,
      .f4map-osm-contributors-link {
        color: #000;
        text-decoration: none;
        cursor: pointer;
      }
      
      .f4map-link:hover,
      .f4map-osm-contributors-link:hover {
        text-decoration: underline;
      }
      
      .maplibregl-ctrl-attrib {
        display: none !important;
      }
      
      .maplibregl-ctrl-attrib-inner {
        display: none !important;
      }
    `
    document.head.appendChild(style)

    containerRef.current.appendChild(footer)

    footerRef.current = footer
    styleRef.current = style

    return () => {
      if (containerRef.current && footer.parentNode) {
        footer.parentNode.removeChild(footer)
      }
      if (style.parentNode) {
        style.parentNode.removeChild(style)
      }
    }
  }, [containerRef])
}
